import EnableCoV from './EnableCoV'

export default EnableCoV
